import { render, staticRenderFns } from "./seat-content.vue?vue&type=template&id=573e824f"
import script from "./seat-content.vue?vue&type=script&lang=js"
export * from "./seat-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports